// extracted by mini-css-extract-plugin
module.exports = {"intro-text":"Telemedicine_intro-text__1mTDQ","empty-state":"Telemedicine_empty-state__3rE-a"};